import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#000", // Main background (pure black)
      paper: "#0B0D0E", // Cards, Paper, Tables (slightly lighter)
      sidebar: "#0d0f12", // Sidebar (even darker)
    },
    primary: { main: "#1976d2" }, // Vibrant blue for buttons/links
    text: {
      primary: "#CDD7E1", // Off-white
      secondary: "#adb5bd", // Muted grey
      disabled: "#49505a",
    },
    divider: "rgba(255, 255, 255, 0.17)",
    action: {
      hover: "rgba(255,255,255,0.03)",
      selected: "rgba(25,118,210,0.15)",
      focus: "rgba(25,118,210,0.12)",
    },
    success: { main: "#1ED760" }, // green for "Paid"
    error: { main: "#D32F2F" }, // red for "Cancelled"
    warning: { main: "#ffa000" }, // amber
    info: { main: "#2196f3" }, // blue
    neutral: { main: "#6c757d" }, // gray for "Refunded"
  },
  typography: {
    fontFamily: ["Inter", "Roboto", "Arial", "sans-serif"].join(","),
    fontWeightMedium: 600,
    fontWeightBold: 800,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#0b0c10",
          color: "#f3f6fa",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#16181d",
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#0B0D0E",
          borderRight: "1px solid rgba(251, 250, 250, 0.48)",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: "#16181d",

          border: "none",
        },
        columnHeaders: {
          backgroundColor: "#131313",

          borderBottom: "1px solid rgba(255,255,255,0.05)",
        },
        cell: {
          borderBottom: "1px solid rgba(255,255,255,0.05)",
        },
        row: {
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.03)",
          },
        },
        footerContainer: {
          backgroundColor: "#16181d",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "0A2744",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected, &.Mui-selected:hover": {
            background: " rgba(245, 245, 245, 0.07) ",
            color: "#ffffff",
            borderRadius: 4,
            paddingTop: 1,
            paddingBottom: 1,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#16181d",
          color: "#f3f6fa",
          borderRadius: 6,
        },
        notchedOutline: {
          borderColor: "rgba(255,255,255,0.09)",
        },
        input: {
          color: "#f3f6fa",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#adb5bd",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          backgroundColor: "#16181d",
          color: "#f3f6fa",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: "0.95em",
        },
        colorSuccess: {
          backgroundColor: "#1ED760",
          color: "#111315",
        },
        colorError: {
          backgroundColor: "#D32F2F",
          color: "#fff",
        },
        colorDefault: {
          backgroundColor: "#23272b",
          color: "#f3f6fa",
        },
        colorInfo: {
          backgroundColor: "#6c757d",
          color: "#fff",
        },
      },
    },
  },
});

export default darkTheme;
